<canvas-drawer [shapes$]="shapes$"></canvas-drawer>
